<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <polygon points="21.72 43.48 2.42 43.48 2.42 1.55 21.72 1.55 21.72 4.55 5.42 4.55 5.42 40.48 21.72 40.48 21.72 43.48" fill="currentcolor"/>
    <path d="M26.05,36.4c-.43,0-.85-.18-1.15-.54-.53-.64-.45-1.58.19-2.11l13.65-11.43-13.65-11.43c-.63-.53-.72-1.48-.19-2.11.53-.64,1.48-.72,2.11-.19l16.4,13.73-16.4,13.73c-.28.23-.62.35-.96.35Z" fill="currentcolor"/>
    <rect x="9.5" y="20.82" width="31.44" height="3" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>